import Http from 'axios'
import {
    API_URL,
    VERSION
} from '../../config/config'

function initialState() {
    return {
        key: null,
        values: [],
        occupations: [],
        relations: [],
    }
}

const getters = {
    key: state => state.key,
    values: state => state.values,
    occupations: state => state.occupations,
    relations: state => state.relations,
};

const actions = {
    fetchDynamicValues({ commit, state }) {
        Http.get(`${API_URL}${VERSION}` + '/dynamic-values-setup/fetch-all', {
            params: {
                key: state.key,
            }
        }).then((response) => {
            let query = response.request.responseURL.split('=')[1];
            switch (query) {
                case 'occupations':
                    commit('setOccupations', response.data);
                    break;
                case 'relations':
                    commit('setRelations', response.data)
                    break;
                default:
                    commit('setValues', response.data);
                    break;
            }
        }).catch()

    }
};

const mutations = {
    setKey(state, item) {
        state.key = item
    },
    setValues(state, items) {
        items = items.map((item) => item.value);
        state.values = items
    },
    setOccupations(state, items) {
        items = items.map((item) => item.value);
        state.occupations = items;
        state.occupations.push('others')
    },
    setRelations(state, items) {
        items = items.map((item) => item.value);
        state.relations = items;
        state.relations.push('others')
    },
};

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations,
}